export const BASEURL = "https://ltd2.krettur.no/" // base url for all api requests.

//export const BASEURL = "http://localhost:3001/v2/" // base url for all api requests.